import {
  GET_LOCATIONS,
  GET_LOCATIONS_SUCCESS,
  GET_LOCATIONS_FAILURE,
  SHOW_GLOBAL_LOADER,
  HIDE_GLOBAL_LOADER,
  GET_HOME_CHARGERS,
  GET_HOME_CHARGERS_SUCCESS,
  GET_HOME_CHARGERS_FAILURE,
} from '../types';

const initialState = {
  show: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SHOW_GLOBAL_LOADER:
    case GET_LOCATIONS:
    case GET_HOME_CHARGERS:
      return {
        show: true,
      };
    case HIDE_GLOBAL_LOADER:
    case GET_LOCATIONS_SUCCESS:
    case GET_LOCATIONS_FAILURE:
    case GET_HOME_CHARGERS_SUCCESS:
    case GET_HOME_CHARGERS_FAILURE:
      return {
        show: false,
      };

    default:
      return state;
  }
};
